// Security test utility functions

// Test for XSS injection
export const testXSSInjection = (input) => {
  const xssTests = [
    '<script>alert("XSS")</script>',
    'javascript:alert("XSS")',
    '<img src="x" onerror="alert(\'XSS\')">',
    '<svg onload="alert(\'XSS\')">',
    '"><script>alert("XSS")</script>',
    '\'><script>alert("XSS")</script>',
    '"><img src=x onerror=alert("XSS")>',
    '\'><img src=x onerror=alert("XSS")>',
    '"><svg onload=alert("XSS")>',
    '\'><svg onload=alert("XSS")>'
  ];

  return xssTests.map(test => input.includes(test)).some(result => result);
};

// Test for SQL injection (even though you're using MongoDB)
export const testSQLInjection = (input) => {
  const sqlTests = [
    "' OR '1'='1",
    "' OR 1=1--",
    "'; DROP TABLE users--",
    "' UNION SELECT * FROM users--",
    "' OR '1'='1' --",
    "' OR '1'='1' #",
    "' OR '1'='1'/*",
    "admin' --",
    "admin' #",
    "admin'/*"
  ];

  return sqlTests.map(test => input.includes(test)).some(result => result);
};

// Test for command injection
export const testCommandInjection = (input) => {
  const commandTests = [
    '; ls',
    '; cat /etc/passwd',
    '; rm -rf /',
    '; mkdir test',
    '; echo "test"',
    '; whoami',
    '; pwd',
    '; netstat',
    '; ps aux',
    '; ifconfig'
  ];

  return commandTests.map(test => input.includes(test)).some(result => result);
};

// Test for NoSQL injection (MongoDB specific)
export const testNoSQLInjection = (input) => {
  const noSqlTests = [
    '{"$gt": ""}',
    '{"$ne": null}',
    '{"$regex": ".*"}',
    '{"$where": "1==1"}',
    '{"$exists": true}',
    '{"$type": "string"}',
    '{"$size": 0}',
    '{"$all": []}',
    '{"$elemMatch": {}}',
    '{"$text": {"$search": ""}}'
  ];

  return noSqlTests.map(test => input.includes(test)).some(result => result);
};

// Test for path traversal
export const testPathTraversal = (input) => {
  const pathTests = [
    '../../../etc/passwd',
    '..\\..\\..\\windows\\win.ini',
    '....//....//....//etc/passwd',
    '....\\\\....\\\\....\\\\windows\\\\win.ini',
    '/etc/passwd',
    'C:\\windows\\win.ini',
    'file:///etc/passwd',
    'file:///C:/windows/win.ini',
    'http://localhost/etc/passwd',
    'http://localhost/C:/windows/win.ini'
  ];

  return pathTests.map(test => input.includes(test)).some(result => result);
};

// Run all security tests
export const runSecurityTests = (input) => {
  const results = {
    xss: testXSSInjection(input),
    sql: testSQLInjection(input),
    command: testCommandInjection(input),
    noSql: testNoSQLInjection(input),
    pathTraversal: testPathTraversal(input)
  };

  return results;
}; 